import { useLayoutEffect as originalUseLayoutEffect } from 'react'

// hydration warning を抑制するための hack
export const useBrowserLayoutEffect =
  typeof window !== 'undefined' ? originalUseLayoutEffect : () => {}

// eslint の deps check を有効化させる hack
const useLayoutEffect = useBrowserLayoutEffect

// サイドメニュー時に背景を固定する
// スクロール追随しないヘッダのハンバーガーメニューからしか使わないので常にスクロール位置は先頭
// (ここが下手にスクロール位置を記憶しようとしてリストのスクロール位置が維持されていなかった)
export function useBackgroundFix(fixed: boolean) {
  useLayoutEffect(() => {
    const style = document.body.style
    if (fixed) {
      style.overflow = 'hidden'
    }
    // ブラウザで戻って unmount されたときには固定をやめる
    return () => {
      style.overflow = ''
    }
  }, [fixed])
}
